<!-- ================== SIDEBAR COMPONENT (SideBar.vue) ================== -->
<template>
  <div>
    <!-- Mobile Toggle Button -->
    <button
      class="mobile-toggle"
      @click="toggleSidebar"
      aria-label="Toggle Menu"
    >
      <i class="fa-solid fa-bars" v-if="!isSidebarOpen"></i>
      <i class="fa-solid fa-times" v-else></i>
    </button>

    <!-- Overlay for mobile -->
    <div
      class="overlay"
      :class="{ active: isSidebarOpen }"
      @click="closeSidebar"
    ></div>

    <!-- Sidebar -->
    <div class="sidebar" :class="{ open: isSidebarOpen }">
      <div class="head_title">
        <router-link to="/" @click="closeSidebar">
          <div class="title">Saubhagya Rai</div>
        </router-link>
        <div class="sub_title">Software Engineer</div>
      </div>
      <ul class="side_menu">
        <li>
          <router-link to="/" @click="closeSidebar">
            <span>0. </span>About Me
          </router-link>
        </li>
        <li>
          <router-link to="/projects" @click="closeSidebar">
            <span>1. </span>Projects
          </router-link>
        </li>
        <li>
          <router-link to="/experience" @click="closeSidebar">
            <span>2. </span>Experience
          </router-link>
        </li>
        <li>
          <router-link to="/skills" @click="closeSidebar">
            <span>3. </span>Skills
          </router-link>
        </li>
        <li>
          <router-link to="/contact" @click="closeSidebar">
            <span>4. </span>Contact Me
          </router-link>
        </li>
      </ul>
      <!-- Footer Block -->
      <div class="sidebar-footer">
        <p class="find-me-text">Find me on</p>

        <ul class="footer_link find_me">
          <li>
            <a href="https://github.com/saubhagyarai" target="_blank">
              <i class="devicon-github-original"></i>
            </a>
          </li>
          <li>
            <a href="https://www.linkedin.com/in/saubhagyarai/" target="_blank">
              <i class="devicon-linkedin-plain"></i>
            </a>
          </li>
          <li>
            <a href="https://twitter.com/saubhagyarai" target="_blank">
              <i class="devicon-twitter-original"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isSidebarOpen: false,
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
    closeSidebar() {
      this.isSidebarOpen = false;
    },
  },
  mounted() {
    window.addEventListener("resize", () => {
      if (window.innerWidth > 768) {
        this.isSidebarOpen = false;
      }
    });
  },
};
</script>

<style scoped>
/* Mobile Toggle Button */
.mobile-toggle {
  display: none;
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 1001;
  /* background: #333; */
  background: white;
  color: white;
  border: none;
  padding: 12px 15px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 20px;
  transition: background 0.3s;
}

.mobile-toggle:hover {
  background: #555;
}

/* Overlay */
.overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  opacity: 0;
  transition: opacity 0.3s;
}

.overlay.active {
  opacity: 1;
}

/* Sidebar Base Styles */
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 300px;
  background: #1a1a1a;
  color: white;
  padding: 40px 30px;
  display: flex;
  flex-direction: column;
  /* justify-content: space-between; */
  overflow-y: auto;
  transition: transform 0.3s ease;
  z-index: 1000;
}

.head_title {
  margin-bottom: 50px;
}

.title {
  font-size: 32px;
  font-weight: bold;
  line-height: 1.2;
  color: white;
  text-decoration: none;
}

.sub_title {
  font-size: 14px;
  color: #888;
  margin-top: 10px;
}

.side_menu {
  list-style: none;
  padding: 0;
  margin: 0 0 auto 0;
}

.side_menu li {
  margin-bottom: 20px;
}

.side_menu a {
  color: #888;
  text-decoration: none;
  font-size: 16px;
  transition: color 0.3s;
  display: inline-block;
}

.side_menu a:hover,
.side_menu a.router-link-active {
  color: white;
}

.side_menu a span {
  color: #4a9eff;
}

.find-me-text {
  text-align: center;
  font-size: 12px;
  color: #666;
  margin-bottom: 10px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

/* .footer_link {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 20px;
  margin-top: 40px;
}

.footer_link a {
  color: #888;
  font-size: 20px;
  transition: color 0.3s;
}

.footer_link a:hover {
  color: white;
}
 */
.sidebar-footer {
  margin-top: auto; /* pushes footer to bottom */
  text-align: center;
}

.find-me-text {
  font-size: 12px;
  color: #666;
  margin-bottom: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.footer_link.find_me {
  display: flex;
  justify-content: center;
  gap: 22px;
}

.footer_link.find_me a {
  font-size: 24px;
  color: #888;
  transition: color 0.3s ease, transform 0.3s ease;
}

.footer_link.find_me a:hover {
  color: #fff;
  transform: translateY(-3px);
}

/* Tablet Styles */
@media (max-width: 1024px) {
  .sidebar {
    width: 240px;
    padding: 50px 20px;
  }

  .title {
    font-size: 28px;
  }
}

/* Mobile Styles */
@media (max-width: 768px) {
  .mobile-toggle {
    display: block;
  }

  .overlay {
    display: block;
  }

  .sidebar {
    transform: translateX(-100%);
    width: 280px;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.3);
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .head_title {
    margin-bottom: 40px;
  }

  .side_menu {
    margin-bottom: 40px;
  }
}

/* Small Mobile Styles */
@media (max-width: 480px) {
  .sidebar {
    width: 75vw;
    max-width: 280px;
  }

  .title {
    font-size: 26px;
  }

  .side_menu a {
    font-size: 15px;
  }
}

/* Sidebar */
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  width: 300px;
  height: 100vh;
  /* background: #0a192f; */
  transform: translateX(0);
  z-index: 20;
}

/* Mobile */
@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }

  .sidebar.open {
    transform: translateX(0);
  }
}

/* Overlay (IMPORTANT FIX) */
.overlay {
  position: fixed;
  inset: 0;
  /* background: rgba(0, 0, 0, 0.4); */
  z-index: 15;

  /* 🔥 CRITICAL */
  pointer-events: none;
}

.overlay.active {
  pointer-events: auto;
}

/* Mobile Toggle */
.mobile-toggle {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 30;
  /* background: transparent; */
  border: none;
  /* color: #64ffda; */
  font-size: 24px;
}
</style>
